import React from 'react';
import { CategoryAndDepartment } from '../../../index';
import RequestorSelector from './RequestorSelector';
import { UserAssociation, PlatformType } from '../types';

interface EnrollmentFormProps {
  siteId: string;
  inAdvancedHierarchy: boolean;
  policySetMapping: any;
  selectedPolicyCategory: any;
  onPolicyCategoryChange: (value: any) => void;
  handleDepartmentChange?: (value: any) => void;
  selectedDepartment?: any;
  selectedOS: PlatformType;
  userAssociations: UserAssociation[];
  selectedRequestor: UserAssociation | null;
  onRequestorChange: (requestor: UserAssociation | null) => void;
  associationsLoading: boolean;
}

const EnrollmentForm: React.FC<EnrollmentFormProps> = ({
  siteId,
  inAdvancedHierarchy,
  policySetMapping,
  selectedPolicyCategory,
  onPolicyCategoryChange,
  handleDepartmentChange,
  selectedDepartment,
  selectedOS,
  userAssociations,
  selectedRequestor,
  onRequestorChange,
  associationsLoading
}) => {
  return (
    <div className="flex col g20">
      <CategoryAndDepartment
        isAdvancedHierarchy={inAdvancedHierarchy}
        policySetMapping={policySetMapping}
        handlePolicyCategoryChange={onPolicyCategoryChange}
        handleDepartmentChange={handleDepartmentChange}
        selectedDepartment={selectedDepartment}
        selectedPolicyCategory={selectedPolicyCategory}
        selectedOS={selectedOS}
        isRequiredDeviceCategory={true}
        isMDMContext={true}
      />
      <RequestorSelector
        userAssociations={userAssociations}
        selectedRequestor={selectedRequestor}
        onRequestorChange={onRequestorChange}
        associationsLoading={associationsLoading}
      />
    </div>
  );
};

export default EnrollmentForm;
